import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_Page = _resolveComponent("Page")!
  const _component_ForCon = _resolveComponent("ForCon", true)!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: item.key
      }, [
        (!item.children)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_a_typography_title, { level: 3 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.title), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_Page, {
                data: item.page
              }, null, 8, ["data"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_a_typography_title, { level: 2 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.title), 1)
                ]),
                _: 2
              }, 1024),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (sub) => {
                return (_openBlock(), _createBlock(_component_ForCon, {
                  data: sub,
                  key: sub.key
                }, null, 8, ["data"]))
              }), 128))
            ]))
      ], 64))
    }), 128))
  ]))
}